import { css } from "@emotion/react";
import React, { useEffect, useState } from "react";
import { useTrelloPowerUpContext } from "../../../external/trello-pu__core/trello-iframe/context";
import { IOtherBoards } from "../../../external/trello-pu__core/trello-iframe/types";
import trelloColors from "../../styles/trello-colors";
import FlexSelect from "../shared/components/flex-select";
// import { ValueType } from 'react-select';
// import { IOtherBoards } from '../../@types';
// import useTrelloRestApi from '../modal/hooks/use-trello-rest-api';
// import trelloColors from '../shared/styles/trello-colors';
// import FlexSelect from '../shared/components/flex-select/flex-select';
// import { trackButtonClick } from '../shared/tracking/tracking';
// import trelloIFrame from '../shared/trello-client/trello-iframe';

type TSelectOption = { label: string; value: string };
type TGroupedSelectOptions = {
  options: TSelectOption[];
  groupName: string;
};
type TCurrentSelections = {
  board: TSelectOption | null;
  listsDone: readonly TSelectOption[] | null;
  listsInProgress: readonly TSelectOption[] | null;
};

type TProps = {
  onSubmit(selectedTargets: TBoardTarget): void;
};

const currentSelectionDefault: TCurrentSelections = {
  board: null,
  listsDone: [],
  listsInProgress: [],
};

const TargetsAdder = (props: TProps) => {
  const { trelloIFrame, restApi } = useTrelloPowerUpContext();

  const [otherBoards, setOtherBoards] = useState<IOtherBoards[]>([]);
  const [currentSelections, setCurrentSelections] =
    useState<TCurrentSelections>(currentSelectionDefault);

  useEffect(() => {
    const idMember = trelloIFrame.getContext().member;
    restApi.fetchAllBoardsForMember(idMember).then(setOtherBoards);
  }, []);

  useEffect(() => {
    if (!currentSelections.board) {
      const currentBoard = getBoard(trelloIFrame.getContext().board);
      setCurrentSelections((prev) => ({
        ...prev,
        board: currentBoard
          ? { value: currentBoard?.id, label: currentBoard?.name }
          : null,
      }));
    }
    otherBoards.length > 0 && trelloIFrame.sizeTo("#card-button");
  }, [otherBoards]);

  useEffect(() => {
    setCurrentSelections((prev) => ({
      ...prev,
      listsDone: [],
      listsInProgress: [],
    }));
  }, [currentSelections.board?.value]);

  const isReadyToSubmit =
    (currentSelections.board &&
      isValidArrayWithValues(currentSelections.listsDone)) ||
    isValidArrayWithValues(currentSelections.listsInProgress);

  const boardsGroupedOptions = getBoardOptions(
    otherBoards,
    trelloIFrame.getContext().board
  );
  const listOptions = getListOptions(
    otherBoards,
    currentSelections.board?.value,
    currentSelections.listsDone,
    currentSelections.listsInProgress
  );
  const boardValue = currentSelections.board
    ? {
        value: currentSelections.board.value,
        label: currentSelections.board.label,
      }
    : null;

  function getBoard(id: string) {
    return otherBoards.find((x) => x.id === id);
  }
  function formatGroupLabel(data: TGroupedSelectOptions) {
    return <span>{data.groupName}</span>;
  }

  function onValueChangeHandler<T extends keyof TCurrentSelections>(
    target: T,
    value: TCurrentSelections[T]
  ) {
    setCurrentSelections((prev) => ({ ...prev, [target]: value }));
  }

  function getListSelectStylingFunc(bgColor: string) {
    const styling = (base, props) => ({
      ...base,
      background: bgColor,
      color: trelloColors.N10,
    });
    return {
      multiValueLabel: styling,
      multiValueRemove: styling,
      menu: (base, props) => ({ ...base, maxHeight: 140 }),
    };
  }

  function submit() {
    const isCurrentBoard =
      trelloIFrame.getContext().board == currentSelections.board?.value;
    // trackButtonClick("AddBoardTarget", {
    //   category: "BulkCardsAttachments",
    //   idBoard: currentSelections.board?.value,
    //   isCurrentBoard,
    //   listsDoneCount: currentSelections.listsDone?.length ?? 0,
    //   listsInProgressCount: currentSelections.listsInProgress?.length ?? 0,
    // });
    if (isReadyToSubmit) {
      const listsDone = (list: readonly TSelectOption[] | null) =>
        isValidArrayWithValues(list)
          ? list.map((l) => ({ id: l.value, name: l.label }))
          : [];
      const targets: TBoardTarget = {
        board: {
          id: currentSelections.board?.value as string,
          name: currentSelections.board?.label as string,
        },
        listsDone: listsDone(currentSelections.listsDone),
        listsWIP: listsDone(currentSelections.listsInProgress),
      };
      props.onSubmit(targets);
      setCurrentSelections(currentSelectionDefault);
    }
  }

  function isValidArrayWithValues(array: any): array is TSelectOption[] {
    return Array.isArray(array) && array.length != 0;
  }

  return (
    <div>
      <FlexSelect
        // css={css`width: auto; margin-left: 8px;`}
        value={boardValue}
        // defaultValue={defaultBoard}
        isMulti={false}
        options={boardsGroupedOptions as TGroupedSelectOptions[]}
        // placeholder={'select board...'}
        formatGroupLabel={formatGroupLabel}
        // isDisabled={!state.dueReminder.isUsed}
        onChange={(option) =>
          onValueChangeHandler("board", option as TCurrentSelections["board"])
        }
        // styles={{ menu: (base, props) => ({ ...base, maxHeight: 150 }) }}
      />
      {/* <div>Done lists</div> */}
      <FlexSelect
        value={currentSelections.listsDone}
        isMulti={true}
        options={listOptions as TSelectOption[]}
        onChange={(option) =>
          onValueChangeHandler(
            "listsDone",
            option as TCurrentSelections["listsDone"]
          )
        }
        styles={getListSelectStylingFunc(trelloColors["green-600"])}
        placeholder={'select lists for "Done"...'}
      />
      {/* <div>Work in Progress lists</div> */}
      <FlexSelect
        value={currentSelections.listsInProgress}
        isMulti={true}
        options={listOptions as TSelectOption[]}
        onChange={(option) =>
          onValueChangeHandler(
            "listsInProgress",
            option as TCurrentSelections["listsInProgress"]
          )
        }
        styles={getListSelectStylingFunc(trelloColors["orange-600"])}
        placeholder={'select lists for "In Progress"...'}
      />
      <button
        css={styles.submitButton}
        className="mod-primary"
        onClick={submit}
        disabled={!isReadyToSubmit}
      >
        Add/Modify target
      </button>
    </div>
  );
};

export default TargetsAdder;

function getBoardOptions(
  boards: IOtherBoards[],
  idCurrentBoard?: string
): TGroupedSelectOptions[] {
  const groupedOptions: TGroupedSelectOptions[] = [];
  const currentBoardsName =
    boards.find((b) => b.id == idCurrentBoard)?.name ?? "N/A: Error!";
  groupedOptions.push({
    groupName: "Current Board",
    options: [{ label: currentBoardsName, value: idCurrentBoard ?? "-1" }],
  });
  boards
    .filter((b) => b.id != idCurrentBoard)
    .forEach((b) => {
      let groupName = "";
      if (b.isGuest || b.isPersonal) groupName = "Boards";
      else if (b.organization?.name) groupName = b.organization.name;

      const group = groupedOptions.find((x) => x.groupName === groupName);
      const label = b.name;
      if (group) {
        group.options.push({ label, value: b.id });
      } else {
        groupedOptions.push({ groupName, options: [{ label, value: b.id }] });
      }
    });
  return groupedOptions;
}

function getListOptions(
  boards: IOtherBoards[],
  idSelectedBord: string | undefined,
  listsDone: TCurrentSelections["listsDone"],
  listsInProgress: TCurrentSelections["listsInProgress"]
) {
  return boards
    .find((b) => b.id === idSelectedBord)
    ?.lists.map((l) => ({ value: l.id, label: l.name }))
    ?.filter(
      (o) =>
        !listsDone?.some((l) => l.value == o.value) &&
        !listsInProgress?.some((l) => l.value == o.value)
    );
}

const styles = {
  submitButton: css`
    width: 100%;
  `,
};
